/* Offers and codes (decision 46a): tap-to-copy chips, and the cart "Offers and codes" panel opens itself when a code can be applied now. */
(function () {
  'use strict';
  if (window.__upkOffersBound) return;
  window.__upkOffersBound = true;

  function fallbackCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); } catch (e) { /* noop */ }
    document.body.removeChild(ta);
  }
  function copyCode(code, btn) {
    var done = function () {
      btn.classList.add('is-copied');
      clearTimeout(btn.__upkT);
      btn.__upkT = setTimeout(function () { btn.classList.remove('is-copied'); }, 2000);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done, function () { fallbackCopy(code); done(); });
    } else {
      fallbackCopy(code);
      done();
    }
  }
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-upk-copy]') : null;
    if (!btn) return;
    e.preventDefault();
    copyCode(btn.getAttribute('data-upk-copy') || '', btn);
  });

  /* The drawer panel opens when at least one code applies now, unless the shopper closed it this session. */
  var CLOSED_KEY = 'upk_offers_closed';
  function closedBefore() { try { return sessionStorage.getItem(CLOSED_KEY) === '1'; } catch (e) { return false; } }
  function openIfUsable() {
    if (closedBefore()) return;
    var panels = document.querySelectorAll('details.upk-code');
    for (var i = 0; i < panels.length; i++) {
      var list = panels[i].querySelector('[data-upk-offers]');
      if (list && parseInt(list.getAttribute('data-ok') || '0', 10) > 0) panels[i].open = true;
    }
  }
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || !d.matches || !d.matches('details.upk-code')) return;
    try { if (!d.open) sessionStorage.setItem(CLOSED_KEY, '1'); else sessionStorage.removeItem(CLOSED_KEY); } catch (err) { /* noop */ }
  }, true);
  function boot() {
    openIfUsable();
    var drawer = document.querySelector('cart-drawer');
    if (drawer && window.MutationObserver) {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () { pending = false; openIfUsable(); });
      }).observe(drawer, { childList: true, subtree: true });
    }
  }
  /* P3 (decision 129): the All offers drawer on the product page (snippets/upk-offers). One drawer open at a time;
     the overlay, the close button and Escape close it. The strip and the drawer carry the same product id. */
  var ofOpenId = null;
  function ofEls(id) {
    return {
      d: document.querySelector('[data-upk-of-drawer="' + id + '"]'),
      o: document.querySelector('[data-upk-of-overlay="' + id + '"]')
    };
  }
  function ofOpen(id) {
    var el = ofEls(id);
    if (!el.d || !el.o) return;
    if (ofOpenId && ofOpenId !== id) ofClose();
    el.d.hidden = false;
    el.o.hidden = false;
    requestAnimationFrame(function () { el.d.classList.add('is-open'); el.o.classList.add('is-open'); });
    document.body.style.overflow = 'hidden';
    ofOpenId = id;
    var c = el.d.querySelector('[data-upk-of-close]');
    if (c && c.focus) { try { c.focus({ preventScroll: true }); } catch (e) { /* noop */ } }
  }
  function ofClose() {
    if (!ofOpenId) return;
    var el = ofEls(ofOpenId);
    ofOpenId = null;
    document.body.style.overflow = '';
    if (!el.d || !el.o) return;
    el.d.classList.remove('is-open');
    el.o.classList.remove('is-open');
    setTimeout(function () { el.d.hidden = true; el.o.hidden = true; }, 280);
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var o = t.closest('[data-upk-of-open]');
    if (o) { e.preventDefault(); ofOpen(o.getAttribute('data-upk-of-open')); return; }
    var c = t.closest('[data-upk-of-close]');
    if (c) { e.preventDefault(); ofClose(); return; }
    if (t.closest('[data-upk-of-overlay]')) ofClose();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') ofClose(); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
